<mat-menu
    #baseMenu="matMenu"
    class="st-editor-menu__mat-menu">
    @for (item of items(); track item) {
        @switch (item.type) {
            @case ('menu') {
                <button
                    class="st-editor-menu__mat-menu__btn"
                    mat-menu-item
                    st-click-stop-propagation
                    [disabled]="item.disabled"
                    [matMenuTriggerFor]="menu.baseMenu()">
                    @if (item.showIcon) {
                        <mat-icon
                            fontSet="material-symbols-outlined"
                            class="st-editor-menu__mat-menu__icon">
                            {{ item.icon }}
                        </mat-icon>
                    }
                    {{ item.label }}
                </button>

                <st-editor-menu
                    #menu
                    [items]="item.options"
                    (onAction)="onAction.emit($event)" />
            }
            @case ('action') {
                @if (item.isDelete) {
                    <button
                        mat-menu-item
                        st-click-stop-propagation
                        class="st-editor-menu__mat-menu__delete-btn"
                        [disabled]="item.disabled"
                        (click)="onActionClick(item)">
                        @if (item.showIcon) {
                            <mat-icon
                                fontSet="material-symbols-outlined"
                                class="st-editor-menu__mat-menu__icon">
                                {{ item.icon }}
                            </mat-icon>
                        }
                        {{ item.label }}
                    </button>
                } @else {
                    <button
                        mat-menu-item
                        st-click-stop-propagation
                        class="st-editor-menu__mat-menu__btn"
                        [disabled]="item.disabled"
                        (click)="onActionClick(item)">
                        @if (item.showIcon) {
                            <mat-icon
                                fontSet="material-symbols-outlined"
                                class="st-editor-menu__mat-menu__icon">
                                {{ item.icon }}
                            </mat-icon>
                        }
                        {{ item.label }}
                    </button>
                }
            }
            @default {
                <mat-divider />
            }
        }
    }
</mat-menu>
